import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	explanationText: {
		id: 'portal-settings-request-groups.page-header.explanation-text',
		defaultMessage:
			"Help customers find the right forms quickly by organizing your portal groups. Forms that aren't assigned to a group will be hidden from your customer portal.",
		description: 'An introduction into what functionality this settings page provides',
	},
	createGroupButton: {
		id: 'portal-settings-request-groups.page-header.create-group-button',
		defaultMessage: 'Create group',
		description: 'Text for create group button',
	},
});
